export const TABS_VIEW_SKELETON_TEST_ID = "tabs-view-skeleton-test-id";

export const TABS_VIEW_TEST_ID = "tabs-view-test-id";

export const TABS_VIEW_BUTTON_SCROLL_ID = "tabs_view_button_scroll_id";
